import React from 'react';
import Typography from '@mui/material/Typography';
import AssetTabularData from './AssetTabularData';
import { ChatResponseAnswer } from '../../pages/ChatPage'

interface AssetFormatTabularDataProps {
  data: ChatResponseAnswer[]
}

const AssetFormatTabularData: React.FC<AssetFormatTabularDataProps> = ({ data: dataProps }) => {
  const xdata = dataProps.filter((k => k.response_data.metric === 'asset'))

  return (
    <>
      <div style={{ padding: 0, margin: 0 }}>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ my: 1 }}
        >
          Asset
        </Typography>
        <AssetTabularData data={xdata} /><br />
      </div>
    </>
  );
}

export default AssetFormatTabularData
